// import { useCallback, useState } from "react";
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import React from 'react';

const Map = (params) => {
  const containerStyle = {
    width: '100%',
    height: '100%',
  };

  const center = {
    lat: 23.746625941445444,
    lng: 90.41282437907465,
  };

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyBuvZx-Iw8fslNBfiBVLgWSG9auhe6asTQ',
  });

  // const [map, setMap] = useState(null);

  // const onLoad = useCallback(function callback(map) {
  //   const bounds = new window.google.maps.LatLngBounds();
  //   map.fitBounds(bounds);
  //   setMap(map);
  // }, []);

  // const onUnmount = useCallback(function callback(map) {
  //   setMap(null);
  // }, []);

  return isLoaded ? (
    <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={16}>
      {/* Child components, such as markers, info windows, etc. */}
      <></>
    </GoogleMap>
  ) : (
    <></>
  );
};
export default React.memo(Map);
